import userId from '@/app/(main)/my/feed/[user-id]';

export const STATION_SIDEBAR_QUERY_KEY = {
  CREATE_POST: (userId: string) => ['create_post', userId] as const,
  SIDEBAR: (userId: string) => ['sidebar_menu', userId] as const,
  TOP_FAN: (userId: string) => ['top_fan', userId] as const,
  SUBSCRIPTION_LIST: (userId: string, type: 'gift' | 'acc') =>
    ['subs_list', type, userId] as const,
} as const;
